/* eslint no-alert:0 */
'use strict';

function mdEditor() {
  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      content: '='
    },
    replace: true,
    template: [
      '<div>',
      '<a href class="button small secondary" ng-click="h1()"><i class="fa fa-header"></i>1</a>',
      '<a href class="button small secondary" ng-click="h2()"><i class="fa fa-header"></i>2</a>',
      '<a href class="button small secondary" ng-click="h3()"><i class="fa fa-header"></i>3</a>',
      '<a href class="button small secondary" ng-click="h4()"><i class="fa fa-header"></i>4</a>',
      '<a href class="button small secondary" ng-click="bold()"><i class="fa fa-bold"></i></a>',
      '<a href class="button small secondary" ng-click="italic()"><i class="fa fa-italic"></i></a>',
      '<a href class="button small secondary" ng-click="link()"><i class="fa fa-chain"></i></a>',
      '<a href class="button small secondary" ng-click="image()"><i class="fa fa-picture-o"></i></a>',
      '<a href class="button small secondary" ng-click="ulist()"><i class="fa fa-list-ul"></i></a>',
      '<a href class="button small secondary" ng-click="olist()"><i class="fa fa-list-ol"></i></a>',
      // '<a href class="button small secondary" ng-click="table()"><i class="fa fa-table"></i></a>',
      '<textarea id="{{ id }}" style="font-family: monospace; font-size: 16px; height: 250px;">{{ content }}</textarea>',
      '<label>Forhåndsvisning</label>',
      '<div id="preview"></div>',
      '</div>'
    ].join(' '),
    link: (scope, el, attr, ctrl) => {
      const editor = el.find('textarea');

      scope.id = attr.id;

      function preview() {
        let converter = new showdown.Converter();
        converter.setOption('tables', true);
        el.find('#preview').html(converter.makeHtml(editor.val()));
      }

      function insert(start, end) {
        if (typeof editor[0] !== 'undefined') {
          let e = editor[0];

          let top = e.scrollTop;
          let before = e.value.substring(0, e.selectionStart);
          let selection = e.value.substring(e.selectionStart, e.selectionEnd);
          let after = e.value.substring(e.selectionEnd, e.value.length);

          e.focus();

          if (e.setSelectionRange) {
            e.value = before + start + selection + end + after;
            e.selectionStart = e.selectionStart;
            e.selectionEnd = e.selectionEnd + start.length + end.length;
            e.scrollTop = top;
          } else {
            if (document.selection && document.selection.createRange) {
              e.focus();
              let range = document.selection.createRange();

              if (range.text !== '') {
                range.text = start + range.text + end;
              } else {
                range.text = start + ' ' + end;
              }

              e.focus();
            }
          }

          scope.content = e.value;
        }
      }

      scope.h1 = () => insert('\n# ', '');
      scope.h2 = () => insert('\n## ', '');
      scope.h3 = () => insert('\n### ', '');
      scope.h4 = () => insert('\n#### ', '');
      scope.bold = () => insert('**', '**');
      scope.italic = () => insert('_', '_');
      scope.ulist = () => insert('\n* ', '');
      scope.olist = () => insert('\n1. ', '');

      scope.table = () => {
        let amount = prompt('Rader', 1);
        // let amountCell = prompt('Kolonner', 1);
        let count = amount === 0 || isNaN(amount) ? 1 : amount;
        let row = '\n|            |            |';
        let rows = '';

        while (count > 0) {
          rows += row;
          count -= 1;
        }

        insert('\n| Kolonner 1 | Kolonner 2 |\n| ---------- | ---------- |' + rows, '');
      };

      scope.image = () => {
        let url = prompt('Bildeegenskaper', 'https://');
        insert('![', '](' + url + ')');
      };

      scope.link = () => {
        let url = prompt('Lenke', 'https://');
        insert('[', '](' + url + ')');
      };

      scope.$watch('content', function (val) {
        editor.val(val);
        preview();
      });

      editor.bind('input propertychange paste', () => {
        ctrl.$setViewValue(el.find('textarea').val());
      });
    }
  };
}

angular
  .module('sr.editor', [])
  .directive('mdEditor', mdEditor);
